import { render, staticRenderFns } from "./InstructorsPage.vue?vue&type=template&id=05db6840"
import script from "./InstructorsPage.vue?vue&type=script&lang=ts"
export * from "./InstructorsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports